import React from 'react';
import { IfmsRoute }from '../../../config/types';
import { LiftingReportView, UsageReportView } from '../../oceanImport/routes';

const Home = React.lazy(() => import('../Home'));

const routes:Array<IfmsRoute> = [
  { path: '/ams/home', component: Home},

  { path: '/ams/amsUsageReport', component: UsageReportView },
  { path: '/ams/amsLiftReport', component: LiftingReportView },
  { path: '/ams/amsTotLiftReport', component: LiftingReportView },
];

export default routes;
